import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Star, Truck, Award, ShieldCheck, Heart,ChevronLeft, ChevronRight, CheckCircle2 } from 'lucide-react';
// import {  bestSellers, testimonials, products } from '../data/mock';
import { testimonials } from '../data/mock';
import { getCategories, getProducts, getBestSellers } from '../services/api';
// import { getCategories } from '../services/api';
import ProductCard from '../components/ProductCard';
import VideoTestimonials from '../components/VideoTestimonials';
import ShopByShape from '../components/ShopByShape';
import { Reveal, RevealItem } from '../components/PageTransition';
import { useSiteConfig } from '../context/SiteConfigContext';
import useSeo from '../hooks/useSeo';

const DEFAULT_HERO_VIDEO = 'https://cdn.coverr.co/videos/coverr-a-close-up-of-wooden-planks-4770/1080p.mp4';
const DEFAULT_BRAND = 'Maa Florist Mumbai';

const extraCats = [
  { id: 'resin-art', name: 'Resin Art', image: 'https://images.unsplash.com/photo-1587533042502-1209d3f2d891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxyZXNpbiUyMHdhbGwlMjBhcnR8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85' },
  { id: 'vastu-clocks', name: 'Vastu Clocks', image: 'https://images.pexels.com/photos/11066021/pexels-photo-11066021.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
];

export default function Home({ onOpen }) {
  const [categories, setCategories] = useState([]);
  const [tabCat, setTabCat] = useState(null);
  const [tabProducts, setTabProducts] = useState([]);   // products for the active tab (fetched per-category)
  const [tabLoading, setTabLoading] = useState(false);
  const [vastuClocks, setVastuClocks] = useState([]);
  const [bestSellers, setBestSellers] = useState([]);

  // Initial page-level fetches: categories, best sellers, and the "popular
  // item" (vastu clocks / luxury-flowers) rail. None of these depend on
  // the tab selection, so they only run once on mount.
  useEffect(() => {
    getCategories().then(cats => {
      setCategories(cats);
      if (cats.length) setTabCat(cats[0].id);
    });
    getBestSellers(4).then(setBestSellers);
    getProducts({ category: 'luxury-flowers', limit: 6 }).then(setVastuClocks);
  }, []);

  // Fetch products scoped to whichever category tab is active. Previously
  // this filtered a single unpaginated `getProducts()` call client-side,
  // which only ever returned page 1 of the catalog (24 of 72 products) —
  // so any category with no items on page 1 (e.g. Birthday Flowers) always
  // rendered empty even though the backend had matching products. Fetching
  // by category directly from the API avoids that entirely.
  useEffect(() => {
    if (!tabCat) return;
    let cancelled = false;
    setTabLoading(true);
    getProducts({ category: tabCat, limit: 4 })
      .then(list => { if (!cancelled) setTabProducts(list); })
      .finally(() => { if (!cancelled) setTabLoading(false); });
    return () => { cancelled = true; };
  }, [tabCat]);

  const circularCats = categories;

  // config is null until the site-config API call resolves — every value
  // pulled from it below has a safe fallback so this page never crashes
  // during that window, and degrades gracefully if the call ever fails.
  const { config } = useSiteConfig();
  const brand       = config?.brand || DEFAULT_BRAND;
  const tagline     = config?.tagline || 'Handcrafted Epoxy Resin Furniture & Art';
  const heroVideoUrl = config?.heroVideoUrl || DEFAULT_HERO_VIDEO;
  const logoUrl     = config?.logoUrl || undefined;
  const phone       = config?.phone || undefined;
  const socials     = config?.socials || {};

  useSeo({
    title:       `${brand} — ${tagline}`,
    description: `Discover ${brand} — a small Mumbai studio handcrafting one-of-a-kind epoxy resin dining tables, coffee tables, wall clocks and art. Free shipping across India.`,
    keywords:    'resin furniture, epoxy resin dining table, live edge, handmade furniture, resin wall art, resin wall clock, India, made in India',
    image:       bestSellers[0]?.image || tabProducts[0]?.image,
    type:        'website',
    canonical:   '/',
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      'name': brand,
      'url': typeof window !== 'undefined' ? window.location.origin : '',
      'logo': logoUrl,
      'contactPoint': [{
        '@type': 'ContactPoint',
        'telephone': phone,
        'contactType': 'customer service',
        'areaServed': 'IN',
      }],
      'sameAs': Object.values(socials).filter(Boolean),
    },
  });

  return (
    <main className="bg-[#f6f2ea]">
      {/* SALE IS LIVE hero (video-first) */}
      <section className="relative overflow-hidden">
        <div className="relative w-full aspect-[5/2] bg-neutral-900">
          <video
            key={heroVideoUrl}
            src={heroVideoUrl}
            poster="https://ecomapi.maafloristmumbai.com/banner.png"
            autoPlay
            muted
            loop
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          />
          {/* <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/30 to-transparent" />
          <div className="absolute inset-0 flex items-end sm:items-center">
            <div className="max-w-7xl mx-auto w-full px-6 sm:px-10 pb-10 sm:pb-0">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: [0.22, 0.61, 0.36, 1] }}
                className="max-w-xl text-white"
              >
                
                <span className="inline-block bg-[#b8935a] text-white text-xs font-semibold tracking-[0.2em] px-3 py-1 rounded mb-4">LIMITED TIME</span>
                <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">SALE IS LIVE!</h1>
                <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1] mt-1">UPTO 70% OFF</h2>
                <Link to="/collection/all" className="mt-6 inline-flex items-center gap-2 bg-white text-[#1e3a2b] hover:bg-neutral-100 px-8 py-3 rounded-md font-bold tracking-wide transition-colors">
                  SHOP NOW <ArrowRight className="w-4 h-4" />
                </Link>
              </motion.div>
            </div>
          </div> */}
        </div>
      </section>

      {/* Tagline */}
      <section className="py-10 sm:py-14 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.6 }}
          transition={{ duration: 0.7, ease: [0.22, 0.61, 0.36, 1] }}
          className="font-serif text-3xl sm:text-4xl lg:text-5xl text-neutral-900 max-w-3xl mx-auto px-6 leading-tight"
        >
          Bring the tranquility of the sea into your home.
        </motion.h2>
      </section>

      {/* Circular category scroller */}
      <section className="pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex gap-6 sm:gap-8 overflow-x-auto no-scrollbar pb-2 justify-start sm:justify-center">
            {circularCats.map(c => (
              <Link key={c.id} to={`/collection/${c.id === 'resin-art' || c.id === 'vastu-clocks' ? 'wall-art' : c.id}`} className="shrink-0 flex flex-col items-center gap-2 group">
                <div className="w-20 h-20 sm:w-28 sm:h-28 rounded-full overflow-hidden ring-2 ring-white shadow group-hover:ring-[#b8935a] transition-all">
                  <img src={c.image} alt={c.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                </div>
                <span className="text-xs sm:text-sm font-medium text-neutral-800 group-hover:text-[#b8935a] transition-colors">{c.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Category tabs */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-1 sm:gap-2 border-b border-neutral-200 overflow-x-auto no-scrollbar">
            {categories.map(c => (
              <button
                key={c.id}
                onClick={() => setTabCat(c.id)}
                className={`px-4 sm:px-6 py-3 text-sm sm:text-base font-medium whitespace-nowrap border-b-2 transition-colors ${tabCat === c.id ? 'border-[#1e3a2b] text-[#1e3a2b]' : 'border-transparent text-neutral-500 hover:text-neutral-900'}`}
              >
                {c.name}
              </button>
            ))}
          </div>

          {tabLoading ? (
            <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-5">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="aspect-square rounded-md bg-neutral-100 animate-pulse" />
              ))}
            </div>
          ) : tabProducts.length === 0 ? (
            <div className="mt-6 py-10 text-center text-neutral-500 text-sm">
              No products in this category yet.
            </div>
          ) : (
            <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-5">
              {tabProducts.map((p, i) => (
                <motion.div
                  key={p.id}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.15 }}
                  transition={{ duration: 0.5, delay: i * 0.08, ease: [0.22, 0.61, 0.36, 1] }}
                >
                  <ProductCard product={p} onOpen={onOpen} />
                </motion.div>
              ))}
            </div>
          )}

          <div className="mt-8 flex justify-center">
            <Link to={`/collection/${tabCat}`} className="bg-[#1e3a2b] hover:bg-[#2a5040] text-white px-8 py-3 rounded-md font-semibold text-sm tracking-wide transition-colors">
              View all
            </Link>
          </div>
        </div>
      </section>

      {/* Google Ranking bar */}
      <section className="py-6 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-center gap-3">
          <span className="grid place-items-center w-9 h-9 rounded-full bg-white ring-1 ring-neutral-200">
            <svg className="w-5 h-5" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
              <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
              <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
            </svg>
          </span>
          <span className="text-xs sm:text-sm font-semibold text-neutral-800 tracking-wide">HANDCRAFTED IN INDIA · REVIEWED ON <span className="font-bold">GOOGLE</span> WITH LOVE</span>
        </div>
      </section>

      {/* Vastu Clocks wave section */}
      <section className="relative bg-[#1e3a2b] text-white overflow-hidden">
        <svg className="absolute top-0 left-0 w-full h-8 sm:h-12 text-white -mb-px" preserveAspectRatio="none" viewBox="0 0 1440 80" fill="currentColor">
          <path d="M0,64 C240,10 480,10 720,40 C960,70 1200,70 1440,20 L1440,0 L0,0 Z" />
        </svg>
        <div className="pt-20 sm:pt-28 pb-24 sm:pb-32 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center">
              <h2 className="font-serif italic text-4xl sm:text-5xl lg:text-6xl">Popular Item</h2>
              <svg className="mx-auto mt-2" width="120" height="10" viewBox="0 0 120 10" fill="none">
                <path d="M2 6 Q30 -2 60 5 T118 4" stroke="#b8935a" strokeWidth="2" strokeLinecap="round" fill="none" />
              </svg>
            </div>
            <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
              {vastuClocks.slice(0, 4).map(p => (
                <div key={p.id} className="bg-white rounded-md overflow-hidden text-neutral-900">
                  <Link to={`/product/${p.id}`} className="block">
                    <div className="relative aspect-square overflow-hidden bg-neutral-100">
                      <img src={p.image} alt={p.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                      {p.save > 0 && (
                        <span className="absolute bottom-3 left-3 bg-[#b8935a] text-white text-xs font-semibold px-2.5 py-1 rounded">
                          SAVE Rs. {p.save.toLocaleString('en-IN')}
                        </span>
                      )}
                    </div>
                    <div className="px-3 pt-3">
                      <h3 className="font-serif text-base line-clamp-1">{p.title.split('|')[0]}</h3>
                      <div className="mt-1 flex items-center gap-1">
                        {Array.from({ length: 4 }).map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />)}
                        <Star className="w-3.5 h-3.5 text-neutral-300" />
                        <span className="text-xs text-neutral-600 ml-1">(1)</span>
                      </div>
                      <div className="mt-1 text-sm">
                        <span className="font-bold">From Rs. {p.price.toLocaleString('en-IN')}</span>{' '}
                        <span className="line-through text-neutral-500 text-xs">Rs. {p.originalPrice.toLocaleString('en-IN')}</span>
                      </div>
                    </div>
                  </Link>
                  <div className="p-3 pt-2">
                    <button
                      onClick={() => onOpen(p)}
                      className="w-full bg-[#1e3a2b] hover:bg-[#2a5040] text-white text-sm font-semibold py-2 rounded-md transition-colors"
                    >
                      Choose options
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-10 flex justify-center">
              <Link to="/collection/luxury-flowers" className="bg-white text-[#1e3a2b] hover:bg-neutral-100 px-8 py-3 rounded-md font-semibold text-sm tracking-wide transition-colors">
                View all
              </Link>
            </div>
          </div>
        </div>
        <svg className="absolute bottom-0 left-0 w-full h-8 sm:h-12 text-white" preserveAspectRatio="none" viewBox="0 0 1440 80" fill="currentColor">
          <path d="M0,16 C240,70 480,70 720,40 C960,10 1200,10 1440,60 L1440,80 L0,80 Z" />
        </svg>
      </section>

      {/* Video testimonials */}
      <VideoTestimonials onOpen={onOpen} />

      {/* Shop by shape */}
      {/* <ShopByShape /> */}

      {/* Shop by category grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-neutral-900 mb-10">
            <em className="font-serif not-italic">Shop By</em> <span className="text-[#7a1e1e] italic">Category</span>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {categories.map(cat => (
              <Link key={cat.id} to={`/collection/${cat.id}`} className="group relative block overflow-hidden rounded-md shadow-sm hover:shadow-xl transition-all">
                <div className="aspect-[4/5] overflow-hidden bg-neutral-100">
                  <img src={cat.image} alt={cat.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                </div>
                <div className="absolute inset-x-0 bottom-0 bg-[#1e3a2b] text-white px-4 py-4 flex items-center justify-between">
                  <span className="font-serif text-xl">{cat.name}</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Best sellers */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-neutral-900">
              <em>Our</em> <span className="text-[#7a1e1e] italic">Best Sellers</span>
            </h2>
            <Link to="/collection/all" className="text-[#1e3a2b] hover:text-[#b8935a] font-semibold text-sm inline-flex items-center gap-1">
              View all <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {bestSellers.slice(0, 4).map(p => (
              <ProductCard key={p.id} product={p} onOpen={onOpen} />
            ))}
          </div>
        </div>
      </section>

      {/* Trust bar */}
      <section className="bg-white border-y border-neutral-200">
        <div className="max-w-7xl mx-auto px-6 py-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            { Icon: Truck, t: 'Free Shipping', s: 'On all prepaid orders' },
            { Icon: ShieldCheck, t: 'Secure Payments', s: '100% protected' },
            { Icon: Heart, t: '100% Handmade', s: 'By master artisans' },
            { Icon: Award, t: 'Award Winning', s: 'India’s #1 Flower Brand' },
          ].map((f, i) => (
            <div key={i} className="flex items-center gap-3 justify-center">
              <f.Icon className="w-8 h-8 text-[#b8935a] shrink-0" />
              <div className="text-left">
                <div className="font-semibold text-[#1e3a2b] text-sm">{f.t}</div>
                <div className="text-xs text-neutral-600">{f.s}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
     <section className="py-16 bg-[#f6f2ea] overflow-hidden">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    {/* Heading */}
    <div className="text-center mb-10">
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-neutral-900">
        <em>What our</em>{" "}
        <span className="text-[#7a1e1e] italic">
          customers say
        </span>
      </h2>

      <div className="flex items-center justify-center gap-2 mt-4">
        <span className="text-sm text-neutral-600">
          Loved by our customers across Mumbai
        </span>

        <div className="flex items-center gap-1">
          <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
          <span className="font-semibold text-sm">4.7/5</span>
        </div>
      </div>
    </div>

    {/* Carousel */}
    <TestimonialCarousel />

  </div>
</section>

      {/* Newsletter */}
      <section className="py-16 bg-[#1e3a2b] text-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h3 className="font-serif text-3xl sm:text-4xl">Join the {brand.split(' ')[0]} family</h3>
          <p className="mt-3 text-neutral-300 text-sm sm:text-base">Get early access to new drops, artisan stories and members-only pricing.</p>
          <form onSubmit={(e) => e.preventDefault()} className="mt-6 flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              required
              placeholder="you@example.com"
              className="flex-1 px-4 py-3 rounded-md text-neutral-900 focus:outline-none focus:ring-2 focus:ring-[#b8935a]"
            />
            <button type="submit" className="bg-[#b8935a] hover:bg-[#a17d47] text-white px-6 py-3 rounded-md font-semibold transition-colors">
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}



function TestimonialCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const [itemsPerView, setItemsPerView] = useState(4);

  // Responsive number of cards
  useEffect(() => {
    const updateItems = () => {
      if (window.innerWidth < 640) {
        setItemsPerView(1);
      } else if (window.innerWidth < 1024) {
        setItemsPerView(2);
      } else {
        setItemsPerView(4);
      }
    };

    updateItems();

    window.addEventListener("resize", updateItems);

    return () => window.removeEventListener("resize", updateItems);
  }, []);

  const maxIndex = Math.max(
    testimonials.length - itemsPerView,
    0
  );

  // Auto slide
  useEffect(() => {
    if (isPaused || maxIndex === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev >= maxIndex ? 0 : prev + 1
      );
    }, 3500);

    return () => clearInterval(interval);
  }, [isPaused, maxIndex]);

  // Keep index valid when resizing
  useEffect(() => {
    if (currentIndex > maxIndex) {
      setCurrentIndex(maxIndex);
    }
  }, [maxIndex, currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev >= maxIndex ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev <= 0 ? maxIndex : prev - 1
    );
  };

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >

      {/* Cards wrapper */}
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-700 ease-out"
          style={{
            transform: `translateX(-${
              currentIndex * (100 / itemsPerView)
            }%)`,
          }}
        >

          {testimonials.map((t, i) => (
            <div
              key={i}
              className="shrink-0 px-2"
              style={{
                width: `${100 / itemsPerView}%`,
              }}
            >

              {/* Review Card */}
              <div
                className="
                  group
                  h-full
                  bg-white
                  rounded-2xl
                  p-5
                  sm:p-6
                  border
                  border-neutral-100
                  shadow-sm
                  hover:shadow-xl
                  hover:-translate-y-1
                  transition-all
                  duration-300
                "
              >

                {/* Top */}
                <div className="flex items-center justify-between mb-4">

                  {/* Google style logo */}
                  <div
                    className="
                      w-9 h-9
                      rounded-full
                      bg-neutral-50
                      flex
                      items-center
                      justify-center
                      font-bold
                      text-lg
                    "
                  >
                    <span className="text-[#4285F4]">G</span>
                  </div>

                  {/* Verified */}
                  <div
                    className="
                      flex
                      items-center
                      gap-1
                      text-xs
                      text-green-700
                      bg-green-50
                      px-2.5
                      py-1
                      rounded-full
                      font-medium
                    "
                  >
                    <CheckCircle2 className="w-3.5 h-3.5" />
                    Verified customer
                  </div>

                </div>

                {/* Stars */}
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star
                      key={k}
                      className="
                        w-4 h-4
                        fill-[#fbbc04]
                        text-[#fbbc04]
                      "
                    />
                  ))}

                  <span className="ml-1 text-xs text-neutral-400">
                    {t.rating}.0
                  </span>
                </div>

                {/* Review */}
                <p
                  className="
                    text-sm
                    text-neutral-700
                    leading-relaxed
                    min-h-[105px]
                  "
                >
                  “{t.text}”
                </p>

                {/* Customer */}
                <div
                  className="
                    mt-5
                    pt-4
                    border-t
                    border-neutral-100
                    flex
                    items-center
                    justify-between
                  "
                >

                  <div>
                    <div
                      className="
                        font-semibold
                        text-[#1e3a2b]
                        text-sm
                      "
                    >
                      {t.name}
                    </div>

                    <div className="text-xs text-neutral-500 mt-0.5">
                      {t.city}, Mumbai
                    </div>
                  </div>

                  {/* Small verified icon */}
                  <CheckCircle2
                    className="w-5 h-5 text-green-600"
                  />

                </div>

              </div>
            </div>
          ))}

        </div>
      </div>

      {/* Previous Button */}
      <button
        type="button"
        onClick={prevSlide}
        aria-label="Previous reviews"
        className="
          absolute
          left-0
          top-1/2
          -translate-y-1/2
          -translate-x-1/2
          hidden
          lg:flex
          w-11
          h-11
          rounded-full
          bg-white
          shadow-lg
          border
          border-neutral-100
          items-center
          justify-center
          text-neutral-700
          hover:bg-[#7a1e1e]
          hover:text-white
          transition-all
          duration-300
          z-10
        "
      >
        <ChevronLeft className="w-5 h-5" />
      </button>

      {/* Next Button */}
      <button
        type="button"
        onClick={nextSlide}
        aria-label="Next reviews"
        className="
          absolute
          right-0
          top-1/2
          -translate-y-1/2
          translate-x-1/2
          hidden
          lg:flex
          w-11
          h-11
          rounded-full
          bg-white
          shadow-lg
          border
          border-neutral-100
          items-center
          justify-center
          text-neutral-700
          hover:bg-[#7a1e1e]
          hover:text-white
          transition-all
          duration-300
          z-10
        "
      >
        <ChevronRight className="w-5 h-5" />
      </button>

      {/* Dots */}
      <div className="flex justify-center items-center gap-2 mt-8">
        {Array.from({
          length: Math.min(maxIndex + 1, 8),
        }).map((_, index) => {

          const active =
            currentIndex === index ||
            (index === 7 && currentIndex >= 7);

          return (
            <button
              key={index}
              type="button"
              onClick={() => setCurrentIndex(index)}
              className={`
                h-2
                rounded-full
                transition-all
                duration-300
                ${
                  active
                    ? "w-7 bg-[#7a1e1e]"
                    : "w-2 bg-neutral-300 hover:bg-neutral-400"
                }
              `}
              aria-label={`Go to review ${index + 1}`}
            />
          );
        })}
      </div>

      {/* Bottom trust text */}
      <div className="text-center mt-5">
        <div className="inline-flex items-center gap-2 text-xs text-neutral-500">
          <CheckCircle2 className="w-4 h-4 text-green-600" />
          Trusted flower delivery in Mumbai & nearby areas
        </div>
      </div>

    </div>
  );
}